import {motion} from 'framer-motion'
import noPfp from '../assets/no_pfp.jpeg'
import teamMatesWorking from '../people/Team54.png'
import teamMatesInMeeting from '../people/Team53.png'
import handsTypingOnLaptops from '../people/Team55.png'
import '../css/Team.css'
import tomiProfilePic from '../people/tomi.jpg'
import TeamMemberProfile from '../components/items/TeamMemberProfile'

function Team() {
  return (
    <main id="team">
        <article className="article_left">
            <motion.div 
                initial={{ opacity: 0, x: -250}}
                whileInView={{opacity: 1, x: 0, transition: { duration: 0.5 }}}
                viewport={{once: true, amount: 0.2 }}
            >
                <p className="pill_text">Meet</p>
                <h1>Meet the team</h1>
                <p className="article_text">At Medbolt, we are proud to have a team of brilliant minds dedicated to revolutionizing healthcare through the power of artificial intelligence.</p>
                <img src={teamMatesWorking} alt='team mates working' />
            </motion.div>
            <motion.div 
                initial={{ opacity: 0, x: 250}}
                whileInView={{opacity: 1, x: 0, transition: { duration: 0.5 }}}
                viewport={{once: true, amount: '1' }}
            >
                <img src={teamMatesInMeeting} alt='team mates in a meeting' />
                <img src={handsTypingOnLaptops} alt='hands typing on a laptop' />
            </motion.div>
        </article>
        <section className="team">
            <p className="pill_text">Profile</p>
            <h1>Team Profile</h1>
            <p>Our diverse and talented group of professionals combines their expertise in medicine, engineering, data science, and technology to create innovative solutions that improve patient outcomes and reshape the future of healthcare.
            </p>
            <div className="profiles">
                <ul className='team-members'>
                    <TeamMemberProfile 
                        team_member={{
                            full_name: 'Habeeb Lawal',
                            role: 'CEO',
                            image: noPfp
                        }}
                    />
                    <TeamMemberProfile 
                        team_member={{
                            full_name: 'Adele Toyibat',
                            role: 'Data Analyst',
                            image: noPfp
                        }}
                    />
                    <TeamMemberProfile 
                        team_member={{
                            full_name: 'Alli Shakirat',
                            role: 'UI/UX Designer',
                            image: noPfp
                        }}
                    />
                    <TeamMemberProfile 
                        team_member={{
                            full_name: 'Akinwande Tomisin',
                            role: 'Frontend Developer',
                            image: tomiProfilePic
                        }}
                    />
                    <TeamMemberProfile 
                        team_member={{
                            full_name: 'Muslimah',
                            role: 'Backend Developer',
                            image: noPfp
                        }}
                    />
                    <TeamMemberProfile 
                        team_member={{
                            full_name: 'Ekene',
                            role: 'Cybersecurity Analyst',
                            image: noPfp
                        }}
                    />
                </ul>
            </div>
        </section>
    </main>
  )
}

export default Team